import { createStore } from 'redux';
import { TypedUseSelectorHook, useSelector } from 'react-redux';
import { rootReducer, RootState } from './reducers';

export const store = createStore(rootReducer);

export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;
